import React from 'react';
import { Paper, Typography, Grid } from '@mui/material';

/**
 * Displays the preview of the allocation details.
 * @param {Object} props - Component props.
 * @param {Object} props.allocateDetails - The allocation details object.
 * @param {number} props.shiftTotalLimit - The total limit of the shift.
 * @returns {JSX.Element|null}
 */
const AllocationPreviewDisplay = ({ allocateDetails, shiftTotalLimit }) => {
  if (!allocateDetails) {
    return null;
  }

  return (
    <Paper elevation={2} sx={{ p: 2, mt: 2 }}>
      <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
        Allocation Preview
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={8}>
          <Typography variant="body2">Total Cases Matching Filters:</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" align="right" fontWeight="medium">
            {allocateDetails.totalFilteredCases}
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography variant="body2">Shift Capacity:</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" align="right" fontWeight="medium">
            {allocateDetails.totalCasesThatCanBeAllocated} / {shiftTotalLimit}
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography variant="body2">Cases Already Allocated in this Shift:</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" align="right" fontWeight="medium">
            {allocateDetails.alreadyAllocatedCases}
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography variant="body2" color="primary" sx={{ fontWeight: 'bold' }}>
            Actual Cases That Will Be Allocated Now:
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" align="right" color="primary" sx={{ fontWeight: 'bold' }}>
            {allocateDetails.languageBasedCount}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AllocationPreviewDisplay;